(() => {
  let busy = false;
  let returnFocus = null;
  const drawer = () => document.querySelector('[data-align-cart-drawer]');
  const cartRoot = () => window.Shopify?.routes?.root || '/';
  const cartUrl = () => cartRoot() + 'cart';
  const message = (text = '') => {
    const status = drawer()?.querySelector('[data-align-cart-status]');
    if (status) status.textContent = text;
  };
  const setBusy = (value) => {
    busy = value;
    const content = drawer()?.querySelector('[data-align-cart-content]');
    content?.setAttribute('aria-busy', String(value));
    content?.querySelectorAll('[data-cart-change], [name="checkout"]').forEach(button => { button.disabled = value; });
  };
  const render = (html) => {
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = parsed.querySelector('[data-align-cart-content]');
    const current = drawer()?.querySelector('[data-align-cart-content]');
    if (!incoming || !current) return false;
    current.replaceWith(incoming);
    const count = Number(incoming.dataset.cartCount);
    document.body.classList.toggle('cart-empty', count === 0);
    document.querySelectorAll('[data-align-cart-count]').forEach(el => { el.textContent = `(${count})`; });
    document.querySelectorAll('[data-align-cart-open]').forEach(el => {
      el.setAttribute('aria-label', el.getAttribute('aria-label').replace(/\(\d+\)/, `(${count})`));
    });
    return true;
  };
  const refresh = async () => {
    const response = await fetch(`${cartUrl()}?section_id=align-cart-drawer`, {headers: {Accept: 'text/html'}, cache: 'no-store'});
    if (!response.ok || !render(await response.text())) throw new Error(drawer()?.dataset.error);
  };
  const open = (trigger) => {
    const dialog = drawer();
    if (!dialog) return;
    if (!dialog.open) {
      returnFocus = trigger;
      dialog.showModal();
      document.body.classList.add('align-cart-open');
    }
  };
  const update = async (button) => {
    if (busy) return;
    const {line, quantity, focus} = button.dataset;
    const errorMessage = drawer().dataset.error;
    message();
    setBusy(true);
    try {
      const response = await fetch(cartRoot() + 'cart/change.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({line: Number(line), quantity: Number(quantity), sections: ['align-cart-drawer'], sections_url: window.location.pathname})
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || errorMessage);
      if (!render(cart.sections?.['align-cart-drawer'])) await refresh();
      document.dispatchEvent(new CustomEvent('align:cart:updated', {detail: cart}));
      setBusy(false);
      const target = drawer().querySelector(`[data-cart-line="${line}"] [data-focus="${focus}"]`) || drawer().querySelector('[data-align-cart-close]');
      target?.focus();
    } catch (error) {
      message(error.message || errorMessage);
    } finally {
      setBusy(false);
    }
  };
  window.AlignCartDrawer = {
    async add(form, trigger) {
      if (busy) throw new Error(drawer()?.dataset.error || 'Please try again.');
      setBusy(true);
      message();
      let added = false;
      try {
        const body = new FormData(form);
        body.set('sections', 'align-cart-drawer');
        body.set('sections_url', window.location.pathname);
        const response = await fetch(cartRoot() + 'cart/add.js', {method: 'POST', body, headers: {Accept: 'application/json'}});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || drawer()?.dataset.error);
        added = true;
        if (!render(data.sections?.['align-cart-drawer'])) await refresh();
        open(trigger);
      } catch (error) {
        if (added) window.location.assign(cartUrl());
        else throw error;
      } finally {
        setBusy(false);
      }
    }
  };
  document.addEventListener('click', async (event) => {
    const dialog = drawer();
    if (!dialog) return;
    const close = event.target.closest('[data-align-cart-close]');
    if (close || event.target === dialog) { dialog.close(); return; }
    const change = event.target.closest('[data-cart-change]');
    if (change) { await update(change); return; }
    const trigger = event.target.closest('[data-align-cart-open]');
    if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    trigger.setAttribute('aria-busy', 'true');
    message();
    try { await refresh(); open(trigger); }
    catch { window.location.assign(trigger.href); }
    finally { setBusy(false); trigger.removeAttribute('aria-busy'); }
  });
  document.addEventListener('close', (event) => {
    if (!event.target.matches?.('[data-align-cart-drawer]')) return;
    document.body.classList.remove('align-cart-open');
    if (returnFocus?.isConnected) returnFocus.focus();
    returnFocus = null;
  }, true);
  document.addEventListener('keydown', (event) => {
    const dialog = drawer();
    if (!dialog?.open || event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      event.preventDefault(); last?.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      event.preventDefault(); first?.focus();
    }
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('[data-align-cart-drawer]')) document.body.classList.remove('align-cart-open');
  });
})();
